import { render, staticRenderFns } from "./ListTransactions.vue?vue&type=template&id=52e728d4"
import script from "./ListTransactions.vue?vue&type=script&lang=js"
export * from "./ListTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports